import classes from "./ConnectorAnchor.module.scss";

/**
 * An invisible 1×1 attachment point for the ConnectorLayer, tagged with
 * the data attributes the layer reads:
 *   - id    → data-conn-anchor (the point's unique id)
 *   - from  → data-conn-from   (if set, the layer draws a line FROM the
 *             anchor with that id INTO this one)
 *
 * `side` picks which edge of the parent it sits on. The parent must be
 * position:relative.
 */
export default function ConnectorAnchor({ id, from, side = "left" }) {
  const sideClass = side === "right" ? classes.right : classes.left;
  return (
    <span
      data-conn-anchor={id}
      {...(from ? { "data-conn-from": from } : {})}
      className={`${classes.anchor} ${sideClass}`}
      aria-hidden="true"
    />
  );
}
